import { render } from "./waiver-question.component.vue?vue&type=template&id=08e116bd&ts=true"
import script from "./waiver-question.component.vue?vue&type=script&lang=ts"
export * from "./waiver-question.component.vue?vue&type=script&lang=ts"

import "./waiver-question.component.vue?vue&type=style&index=0&id=08e116bd&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__